import {TOGGLE_SIDEBAR} from '../constants'

export function toggleSidebar() {
  return {type: TOGGLE_SIDEBAR}
}
